import React, { useState, useRef, useEffect } from "react";

import { useFormCtx } from "./FormContext";
import useScreenType from "./hooks/useScreenType";

import * as Const from "./_Const";

import Navbar from "./components/Navbar";
import Button from "./components/Button";
import ScaleSpinnerProgressSection from "./components/ScaleSpinnerProgressSection";
import Dialog from "./components/Dialog";
import toast from "react-hot-toast";
import * as TerminalService from "./services/data/TerminalService";

const MAX = "MAX";
const MIN = "MIN";
const MAX_DISP_VAL = 255;

function PageBrightnessSoundLed() {
  const screenType = useScreenType();
  const { instance, loaded, terminalSettingsState, setBrightnessTo } = useFormCtx();

  const [isBrightnessEnabled, setBrightnessEnabled] = useState(false);

  const [isOnMax, setOnMax] = useState(false);
  const [maxBrightness, setMaxBrightness] = useState(0);

  const [isOnMin, setOnMin] = useState(false);
  const [minBrightness, setMinBrightness] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function scopedLoadData() {
      //loada data
      if (loaded) {
        setMaxBrightness(terminalSettingsState?.brightnessMax);
        setMinBrightness(terminalSettingsState?.brightnessMin);
        setBrightnessEnabled(terminalSettingsState?.isBrightnessAdjustmentEnabled);
      }
    }

    scopedLoadData();
  }, [loaded]);

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_RPIV1) {
      switch (what) {
        case "key":
          css = "min-w-[108px] text-secondary text-sm";
          break;
        case "val":
          css = "ml-2 text-sm";
          break;
        case "block":
          css = "mx-4";
          break;
        case "block-title":
          css = "text-xl text-accent-dark mt-2";
          break;
        case "footer":
          css = "h-[65px]";
          break;
        case "parent":
          css = "h-[416px]";
          break;
        case "btn":
          css = "h-14 text-sm";
          break;
        case "pm-btn":
          css = "h-11 w-11 text-base mr-2";
          break;
        case "toggle-btn":
          css = "h-11 w-11 text-base";
          break;
        case "toggle-btn-right":
          css = "h-11 w-11 text-base mr-2";
          break;
        case "bottom-btn":
          css = "h-11 text-base min-w-60";
          break;
        case "bottom-btn-grid":
          css = "bottom-2";
          break;
        case "btn-text-left":
          css = "text-xl mr-2 min-w-11 mb-1";
          break;
        case "btn-text-right":
          css = "text-xl ml-2 min-w-11";
          break;
        case "hint":
          css = "text-base mx-4 mt-8";
          break;
        case "btn-grid":
          css = "mx-4 mt-8 mb-2 gap-8";
          break;
        case "parent-block-div":
          css = "mx-4 mt-8";
          break;
        case "cbx":
          css = "w-6 h-6";
          break;
        case "div-cbx":
          css = "gap-2 mt-8";
          break;
      }
    } else if (screenType === Const.SCREEN_RPIV2) {
      switch (what) {
        case "key":
          css = "min-w-[190px] text-secondary text-xl";
          break;
        case "val":
          css = "ml-4 text-xl";
          break;
        case "block":
          css = "mx-4";
          break;
        case "block-title":
          css = "text-2xl text-accent-dark mt-4";
          break;
        case "footer":
          css = "h-[100px]";
          break;
        case "parent":
          css = "h-[624px]";
          break;
        case "btn":
          css = "h-20";
          break;
        case "pm-btn":
          css = "h-[62px] w-[62px] text-2xl mr-4";
          break;
        case "toggle-btn":
          css = "h-[62px] w-[62px] text-2xl";
          break;
        case "toggle-btn-right":
          css = "h-[62px] w-[62px] text-2xl mr-4";
          break;
        case "bottom-btn":
          css = "h-[62px]  text-xl min-w-80";
          break;
        case "bottom-btn-grid":
          css = "bottom-4";
          break;
        case "btn-text-left":
          css = "text-3xl mr-4 min-w-16 mb-1";
          break;
        case "btn-text-right":
          css = "text-3xl ml-4 min-w-16";
          break;
        case "hint":
          css = "text-xl mx-6 mt-8";
          break;
        case "btn-grid":
          css = "mx-6 mt-8 mb-2 gap-4";
          break;
        case "parent-block-div":
          css = "mx-6 mt-8";
          break;
        case "cbx":
          css = "w-8 h-8";
          break;
        case "div-cbx":
          css = "gap-2 mt-8";
          break;
      }
    } else if (screenType === Const.SCREEN_WAVESHARE) {
      switch (what) {
        case "key":
          css = "min-w-[190px] text-secondary text-xl";
          break;
        case "val":
          css = "ml-4 text-xl";
          break;
        case "block":
          css = "mx-4";
          break;
        case "block-title":
          css = "text-2xl text-accent-dark mt-4";
          break;
        case "footer":
          css = "h-[100px]";
          break;
        case "parent":
          css = "h-[704px]";
          break;
        case "btn":
          css = "h-20";
          break;
        case "pm-btn":
          css = "h-16 w-16 text-2xl mr-4";
          break;
        case "toggle-btn":
          css = "h-16 w-16 text-2xl";
          break;
        case "toggle-btn-right":
          css = "h-16 w-16 text-2xl mr-4";
          break;
        case "bottom-btn":
          css = "h-20 text-xl min-w-80";
          break;
        case "bottom-btn-grid":
          css = "bottom-4";
          break;
        case "btn-text-left":
          css = "text-3xl mr-4 min-w-16 mb-1";
          break;
        case "btn-text-right":
          css = "text-3xl ml-4 min-w-16";
          break;
        case "hint":
          css = "text-2xl mx-8 mt-16";
          break;
        case "btn-grid":
          css = "mx-8 mt-16 mb-2 gap-8";
          break;
        case "parent-block-div":
          css = "mx-8 mt-16";
          break;
        case "cbx":
          css = "w-10 h-10";
          break;
        case "div-cbx":
          css = "gap-4 mt-16";
          break;
      }
    }

    return css;
  }

  function plus(what) {
    //console.log("plus", what);
    switch (what) {
      case MAX:
        setMaxBrightness(getVal(+(maxBrightness + (isOnMax ? 10 : 1)), MAX_DISP_VAL));
        break;
      case MIN:
        setMinBrightness(getVal(+(minBrightness + (isOnMin ? 10 : 1)), MAX_DISP_VAL));
        break;
    }
  }

  function minus(what) {
    //console.log("minus", what);

    switch (what) {
      case MAX:
        setMaxBrightness(getVal(+(maxBrightness - (isOnMax ? 10 : 1)), MAX_DISP_VAL));
        break;
      case MIN:
        setMinBrightness(getVal(+(minBrightness - (isOnMin ? 10 : 1)), MAX_DISP_VAL));
        break;
    }
  }

  function getVal(val, max) {
    let retVal = val;
    if (val > max) {
      retVal = max;
    } else if (val < 0) {
      retVal = 0;
    }
    // console.log(val, max, retVal);

    return retVal;
  }

  async function postBrightnessDataToApi() {
    try {
      setIsLoading(true);
      await TerminalService.setBrightnessEnabled(instance, terminalSettingsState?.mobileUID, isBrightnessEnabled, maxBrightness, minBrightness);
      console.log("API Brightness data uloženy");
      toast.success("Údaje úspěšně uloženy do API");
    } catch (ex) {
      const e = "Chyba při ukládání parametrů jasu do API";
      console.log(e, ex);
      setError(e);
    } finally {
      setIsLoading(false);
    }
  }

  const showContent = !error && !isLoading;

  return (
    <>
      <Navbar useCustomTitle={true} customTitle={"Nastavení jasu displeje"} />
      {isLoading && <ScaleSpinnerProgressSection />}
      {error && <Dialog buttonText="Zavřít" type="error" title={"Chyba při zpracování požadavku"} message={error} onClick={() => setError("")} />}
      {showContent && (
        <div className="h-[416px] scRPIV2:h-[624px] scWaveShare:h-[704px] tvFullHD:h-[900px] tv4K:h-[1800px] flex flex-col overflow-hidden">
          <div className="text-base mx-4 mt-8 scRPIV2:text-xl scRPIV2:mx-6 scRPIV2:mt-8 scWaveShare:text-2xl scWaveShare:mx-8 scWaveShare:mt-16 tvFullHD:text-2xl tvFullHD:mx-8 tvFullHD:mt-16 tv4K:text-6xl tv4K:mx-16 tv4K:mt-32 text-accent">
            <p>U originálních Raspberry displejů V1 a V2 je maximální hodnota jasu 255</p>
            <p>U displejů připojených přes HDMI například WaveShare je maximální hodnota jasu 100</p>

            <div className="gap-2 mt-8 scWaveShare:gap-4 scWaveShare:mt-16 flex items-center ">
              <input
                type="checkbox"
                id="enable-cbx"
                checked={isBrightnessEnabled}
                onChange={(e) => setBrightnessEnabled(e.target.checked)}
                className="size-6 scRPIV2:size-8 scWaveShare:size-10 tvFullHD:size-10 tv4K:size-20 rounded accent-accent bg-accent-dark cursor-pointer"
              />
              <label for="enable-cbx" className="cursor-pointer select-none">
                Povolit úpravu jasu displeje
              </label>
            </div>

            {/* <input
            type="checkbox"
            className="appearance-none w-6 h-6 border-2 border-green-600 rounded bg-accent-dark
         checked:bg-accent accent-accent"
          /> */}
          </div>

          <div
            className={`mx-4 mt-8 scRPIV2:mx-6 scRPIV2:mt-8 scWaveShare:mx-8 scWaveShare:mt-16 tvFullHD:mx-8 tvFullHD:mt-16 tv4K:mx-16 tv4K:mt-32 grid grid-cols-2 ${!isBrightnessEnabled ? "pointer-events-none opacity-50" : ""}`}
          >
            <div>
              <p className="text-accent scRPIV2:text-xl scWaveShare:text-2xl scWaveShare:mb-2 tvHD:mb-2 tvFullHD:text-2xl tvFullHD:mb-4 tv4K:text-6xl tv4K:mb-8">
                Maximální jas
              </p>
              <div className="flex flex-row items-center">
                <div className="text-xl mr-2 min-w-11 scRPIV2:text-3xl scRPIV2:mr-4 scRPIV2:min-w-16 tvFullHD:mr-8 tvFullHD:min-w-20 tvFullHD:text-5xl tv4K:text-8xl tv4K:min-w-40 tv4K:mr-16 text-primary">
                  {maxBrightness}
                </div>
                <Button
                  type="terminal-dark"
                  forceBeepDisabled={true}
                  className="size-11 text-base mr-2 scRPIV2:size-[62px] scRPIV2:text-2xl scRPIV2:mr-4 scWaveShare:size-16 scWaveShare:text-2xl scWaveShare:mr-4 tvFullHD:size-24 tvFullHD:text-3xl tvFullHD:mr-8 tv4K:size-44 tv4K:text-6xl tv4K:mr-12 rounded-none"
                  title="0"
                  onClick={() => setMaxBrightness(0)}
                  showIcon={false}
                />
                <Button
                  type="terminal-dark"
                  forceBeepDisabled={true}
                  className="size-11 text-base mr-2 scRPIV2:size-[62px] scRPIV2:text-2xl scRPIV2:mr-4 scWaveShare:size-16 scWaveShare:text-2xl scWaveShare:mr-4 tvFullHD:size-24 tvFullHD:text-3xl  tvFullHD:mr-8 tv4K:size-44 tv4K:text-6xl tv4K:mr-12 rounded-none"
                  title="100"
                  onClick={() => setMaxBrightness(100)}
                  showIcon={false}
                />
                <Button
                  type="terminal-dark"
                  forceBeepDisabled={true}
                  className="size-11 text-base mr-2 scRPIV2:size-[62px] scRPIV2:text-2xl scRPIV2:mr-4 scWaveShare:size-16 scWaveShare:text-2xl scWaveShare:mr-4 tvFullHD:size-24 tvFullHD:text-3xl  tvFullHD:mr-8 tv4K:size-44 tv4K:text-6xl tv4K:mr-12 rounded-none"
                  title={MAX_DISP_VAL.toString()}
                  onClick={() => setMaxBrightness(MAX_DISP_VAL)}
                  showIcon={false}
                />
                <Button
                  type="terminal-dark"
                  forceBeepDisabled={true}
                  className="size-11 text-base mr-2 scRPIV2:size-[62px] scRPIV2:text-2xl scRPIV2:mr-4 scWaveShare:size-16 scWaveShare:text-2xl scWaveShare:mr-4 tvFullHD:size-24 tvFullHD:text-3xl tvFullHD:mr-8 tv4K:size-44 tv4K:text-6xl tv4K:mr-12 rounded-none"
                  title="+"
                  onClick={() => plus(MAX)}
                  showIcon={false}
                />
                <Button
                  type="terminal-dark"
                  forceBeepDisabled={true}
                  className="size-11 text-base mr-2 scRPIV2:size-[62px] scRPIV2:text-2xl scRPIV2:mr-4 scWaveShare:size-16 scWaveShare:text-2xl scWaveShare:mr-4 tvFullHD:size-24 tvFullHD:text-3xl tvFullHD:mr-8 tv4K:size-44 tv4K:text-6xl tv4K:mr-12 rounded-none"
                  title="-"
                  onClick={() => minus(MAX)}
                  showIcon={false}
                />

                <Button
                  type="toggle"
                  forceBeepDisabled={true}
                  className="size-11 text-base scRPIV2:size-[62px] scRPIV2:text-2xl scWaveShare:size-16 scWaveShare:text-2xl  tvFullHD:size-24 tvFullHD:text-3xl tv4K:size-44 tv4K:text-6xl rounded-none"
                  title="x10"
                  onToggleStateChange={setOnMax}
                  toggleState={isOnMax}
                />
              </div>
            </div>

            <div>
              <p className="text-accent scRPIV2:text-xl scWaveShare:text-2xl scWaveShare:mb-2 tvHD:mb-2 tvFullHD:text-2xl tvFullHD:mb-4 tv4K:text-6xl tv4K:mb-8 text-right">
                Minimální jas
              </p>
              <div className="flex flex-row items-center place-content-end">
                <Button
                  type="toggle"
                  forceBeepDisabled={true}
                  className="size-11 text-base mr-2 scRPIV2:size-[62px] scRPIV2:text-2xl scRPIV2:mr-4  scWaveShare:size-16 scWaveShare:text-2xl scWaveShare:mr-4 tvFullHD:size-24 tvFullHD:text-3xl  tvFullHD:mr-8 tv4K:size-44 tv4K:text-6xl tv4K:mr-12 rounded-none"
                  title="x10"
                  onToggleStateChange={setOnMin}
                  toggleState={isOnMin}
                />
                <Button
                  type="terminal-dark"
                  forceBeepDisabled={true}
                  className="size-11 text-base mr-2 scRPIV2:size-[62px] scRPIV2:text-2xl scRPIV2:mr-4 scWaveShare:size-16 scWaveShare:text-2xl scWaveShare:mr-4 tvFullHD:size-24 tvFullHD:text-3xl  tvFullHD:mr-8 tv4K:size-44 tv4K:text-6xl tv4K:mr-12 rounded-none"
                  title="+"
                  onClick={() => plus(MIN)}
                  showIcon={false}
                />
                <Button
                  type="terminal-dark"
                  forceBeepDisabled={true}
                  className="size-11 text-base mr-2 scRPIV2:size-[62px] scRPIV2:text-2xl scRPIV2:mr-4 scWaveShare:size-16 scWaveShare:text-2xl scWaveShare:mr-4 tvFullHD:size-24 tvFullHD:text-3xl  tvFullHD:mr-8 tv4K:size-44 tv4K:text-6xl tv4K:mr-12 rounded-none"
                  title="-"
                  onClick={() => minus(MIN)}
                  showIcon={false}
                />
                <Button
                  type="terminal-dark"
                  forceBeepDisabled={true}
                  className="size-11 text-base mr-2 scRPIV2:size-[62px] scRPIV2:text-2xl scRPIV2:mr-4 scWaveShare:size-16 scWaveShare:text-2xl scWaveShare:mr-4 tvFullHD:size-24 tvFullHD:text-3xl tvFullHD:mr-8 tv4K:size-44 tv4K:text-6xl  tv4K:mr-12 rounded-none"
                  title="0"
                  onClick={() => setMinBrightness(0)}
                  showIcon={false}
                />
                <Button
                  type="terminal-dark"
                  forceBeepDisabled={true}
                  className="size-11 text-base mr-2 scRPIV2:size-[62px] scRPIV2:text-2xl scRPIV2:mr-4 scWaveShare:size-16 scWaveShare:text-2xl scWaveShare:mr-4 tvFullHD:size-24 tvFullHD:text-3xl tvFullHD:mr-8 tv4K:size-44 tv4K:text-6xl  tv4K:mr-12 rounded-none"
                  title="100"
                  onClick={() => setMinBrightness(100)}
                  showIcon={false}
                />
                <Button
                  type="terminal-dark"
                  forceBeepDisabled={true}
                  className="size-11 text-base mr-2 scRPIV2:size-[62px] scRPIV2:text-2xl scRPIV2:mr-4 scWaveShare:size-16 scWaveShare:text-2xl scWaveShare:mr-4 tvFullHD:size-24 tvFullHD:text-3xl tvFullHD:mr-8 tv4K:size-44 tv4K:text-6xl  tv4K:mr-12 rounded-none"
                  title={MAX_DISP_VAL.toString()}
                  onClick={() => setMinBrightness(MAX_DISP_VAL)}
                  showIcon={false}
                />
                <div className="text-xl ml-2 min-w-11 scRPIV2:text-3xl scRPIV2:ml-4 scRPIV2:min-w-16 tvFullHD:ml-8 tvFullHD:min-w-20 tvFullHD:text-5xl tv4K:text-8xl tv4K:min-w-40 tv4K:ml-16 text-primary">
                  {minBrightness}
                </div>
              </div>
            </div>
          </div>

          <div
            className={`mx-4 mt-8 mb-2 gap-8 scRPIV2:mx-6 scRPIV2:mt-8 scRPIV2:mb-2 scRPIV2:gap-4 scWaveShare:mx-8 scWaveShare:mt-16 scWaveShare:mb-2 scWaveShare:gap-8 tvFullHD:mx-16 tvFullHD:mt-32 tvFullHD:mb-2 tvFullHD:gap-16 tv4K:mx-16 tv4K:mt-32 tv4K:mb-2 tv4K:gap-16 overflow-y-auto grid grid-cols-2   ${!isBrightnessEnabled ? "pointer-events-none opacity-50" : ""}`}
          >
            {/* jas  */}

            <Button
              title={"Vyzkoušet - MAX jas displeje"}
              showIcon={false}
              className="h-16 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-40 tvFullHD:text-2xl tv4K:h-80 tv4K:text-6xl"
              onClick={() => setBrightnessTo(Const.STATE_MAX, maxBrightness, 0)}
            />
            <Button
              title={"Vyzkoušet - MIN jas displeje"}
              showIcon={false}
              className="h-16 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-40 tvFullHD:text-2xl tv4K:h-80 tv4K:text-6xl"
              onClick={() => setBrightnessTo(Const.STATE_MIN, 0, minBrightness)}
            />
          </div>

          <div className="bottom-2 scRPIV2:bottom-4 scWaveShare:bottom-4 tvFullHD:bottom-4 tv4K:bottom-8 w-full absolute left-0 place-items-center">
            <Button
              type="terminal-dark"
              title="Uložit do API"
              showIcon={false}
              onClick={async () => await postBrightnessDataToApi()}
              className="h-11 text-base min-w-60 scRPIV2:h-[62px]  scRPIV2:text-xl scRPIV2:min-w-80 scWaveShare:h-20 scWaveShare:text-xl scWaveShare:min-w-80 tvFullHD:h-28 tvFullHD:text-3xl tvFullHD:min-w-[28rem] tv4K:h-40 tv4K:text-6xl tv4K:min-w-[40rem] rounded-none"
            />
          </div>
        </div>
      )}
    </>
  );
}

export default PageBrightnessSoundLed;
